import * as React from "react"
import { SVGProps } from "react"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Livello_2"
    width={48}
    height={48}
    data-name="Livello 2"
    {...props}
  >
    <defs>
      <style>
        {
          ".cls-234{fill:none;stroke:#00a4b7;stroke-miterlimit:10;stroke-width:2px}"
        }
      </style>
    </defs>
    <g id="Palette">
      <circle
        cx={24}
        cy={24}
        r={24}
        style={{
          fill: "#060b0c",
          strokeWidth: 0,
        }}
      />
      <path d="M25.66 6.02 20 11.68l5.66 5.66" className="cls-234" />
      <path
        d="M15.29 15.29A12.282 12.282 0 0 0 11.68 24c0 6.8 5.52 12.32 12.32 12.32S36.32 30.8 36.32 24 30.8 11.68 24 11.68h-4"
        className="cls-234"
      />
    </g>
  </svg>
)
export default SvgComponent
